import { useLocation, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { outsidePasswordProtectionPaths } from "@/components/PasswordProtection";
import type { FileRoutesByTo } from "@/routeTree.gen";
import { useSelskaper } from "./selskap/SelskapContext";

const selskapPath: keyof FileRoutesByTo = "/selskap";
const homePath: keyof FileRoutesByTo = "/bestillinger";
const landingPage: keyof FileRoutesByTo = "/";

export const RouteGuards = ({ children }: { children: React.ReactNode }) => {
  const { active } = useSelskaper();
  const router = useRouter();
  const location = useLocation();

  useEffect(() => {
    // Vi lar /_app/routes.tsx ta seg av auth redirect, mens RouteGuard beskytter sidene hvis man er innlogget
    if (
      (outsidePasswordProtectionPaths as string[]).includes(location.pathname)
    ) {
      return;
    } else if (active == null && location.pathname !== selskapPath) {
      router.navigate({ to: selskapPath });
    } else if (location.pathname === landingPage) {
      router.navigate({ to: homePath });
    }
  }, [active, router.navigate, location]);

  return <>{children}</>;
};
